
import Dropzone from "dropzone";
import Cropper from 'cropperjs'; 
import 'cropperjs/dist/cropper.css';

export default {
  name: 'FlipImage',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
          "@type": "Question",
          "name": "What happens when you flip an image?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "When flipped, the image will be upside down and reflected in the vertical or horizontal axis, depending on your preference."
          }
      },{
          "@type": "Question",
          "name": "Why does flipping a picture make it look better?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "Flipping the photo will produce a relatively realistic image instead of mirroring options."
          }
      },{
          "@type": "Question",
          "name": "What are the steps to flip an image?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "Most tools today support flipping images in three steps: Open or upload the image to be edited. Select \"Flip Image\" in the toolbar and set the image to flip vertically or horizontally. After successfully flipping the image, you can continue to edit and download the image."
          }
      },{
          "@type": "Question",
          "name": "What are the two ways to flip a picture?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "There are two main ways to flip photos: Vertical and horizontal flip. Each method produces a different reflection effect. If you flip it vertically, you'll get photos that use the reflection effect in the mirror."
          }
      },{
          "@type": "Question",
          "name": "What is the difference between rotate and flip?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "When you rotate the image, it remains in the same subject orientation relative to you. Whereas with the flip picture, the object will flip vertically or horizontally. At this point, the thing is just a mirror image."
          }
      }]
    };
  },
  data() {
    return {
        filesSelected: 0,
        local_image: null,
        progress: 0,
        loading: false,
        isActive: false,
        form: this.$vform({ })
    };
  },
  mounted() {

        Dropzone.autoDiscover = false;

        let vm = this;

        var uploadedImageType = 'image/jpeg', uploadedImageName = 'image.jpg';

        var errors = false;

        var myDropzone = new Dropzone(".dropzone", { 
           maxFilesize: 5,
           autoProcessQueue: false,
           maxFiles:1,
           acceptedFiles: "image/*",
           previewsContainer: false,
           thumbnailWidth: null,
           thumbnailHeight: null,
           addedfile: function (file) {
                errors = false;
                if (this.files.length > 1) {
                  this.removeFile(this.files[0]);
                }
           },
           error: function (file, message) {
                this.removeFile(file);
                alert(message);
                errors = true;
           },
           thumbnail: function(file, dataUrl) {

                if(errors) return;
                if (/^image\/\w+/.test(file.type)) {
                    uploadedImageName = file.name;
                    uploadedImageType = file.type;                  
                }

                // start file reader
                let result = document.querySelector('#preview-image'), cropper = '';
                const reader = new FileReader();
                reader.onload = (e)=> {
                    // create new image
                    let img          = document.createElement('img');
                    img.id           = 'image';
                    img.className    = 'img-fluid';
                    img.src          = dataUrl;
                    result.innerHTML = '';
                    result.appendChild(img);
                    initCropper( uploadedImageName, uploadedImageType );

                };
                reader.readAsDataURL(file);
           }
        });

        initCropper( uploadedImageName, uploadedImageType );

        function initCropper( fileName, fileType ){

            // init cropper
            var cropper = window.Cropper;
            var URL     = window.URL || window.webkitURL;
            var image   = document.querySelector('#image');

            var options = {
                dragMode: 'none',
                aspectRatio: 16 / 9,
                autoCrop: false,
                zoomable: false,
                background: false,
                toggleDragModeOnDblclick: false,
                viewMode: 3
            };

            cropper = new Cropper(image, options);

            // Methods
            document.querySelector('.flip_image').onclick = function(event) {
                var e      = event || window.event;
                var target = e.target || e.srcElement;
                var cropped;
                var result;
                var data;

                while (target !== this) {
                  if (target.getAttribute('data-method')) {
                    break;
                  }

                  target = target.parentNode;
                }

                data = {
                  method: target.getAttribute('data-method'),
                  option: target.getAttribute('data-option') || undefined
                };

                cropped = cropper.cropped;

                if (data.method) {

                  result = cropper[data.method](data.option);

                  switch (data.method) {

                    case 'scaleX':
                    case 'scaleY':
                        target.setAttribute('data-option', -data.option);
                      break;

                    case 'getCroppedCanvas':

                        if (result) {

                            result.toBlob(function(blob) {

                                vm.onFlipImage(URL.createObjectURL(blob), fileName);

                            }, fileType)
                            
                        }

                      break;

                  }

                }
            };
        }
  },
  methods: {
    onConvertType: function() {
      this.isActive = !this.isActive;
    },
    handleFileChange(event) {
        this.progress      = 0;
        this.filesSelected = event.target.files.length;
        this.local_image   = event.target.files[0];
    },
    onFlipImage(blobURL, fileName) {

        jQuery('.download-image').attr( 'href',  blobURL);

        jQuery('.preview-download-image').attr('src', blobURL);

        jQuery('.download-image').attr('data-filename', fileName);

        jQuery('#modalPreviewDownloadImage').modal('show');
    },
    onDownloadImage( image ) {
        const link   = document.createElement('a');
        var filename = image.srcElement.dataset.filename;
        link.href    = image.srcElement.href;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    }
    //
  }
}
